// @flow
import localforage from 'localforage';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { setRedirectingToCount, incrementRedirectingToCount } from './actions';
import { getRedirectingToCount } from './selectors';
import {
  LOAD_REDIRECTING_TO_COUNT,
  INCREMENT_REDIRECTING_TO_COUNT,
  REDIRECT_REDIRECTING_TO,
} from './actionTypes';
import { LOCALFORAGE_KEYS, REDIRECT_DELAY_TIME } from '../constants';

export function* loadCountFromStorage(): Generator<*, *, *> {
  if (!navigator.cookieEnabled) {
    return;
  }
  try {
    const storageCount = yield call(
      [localforage, localforage.getItem],
      LOCALFORAGE_KEYS.redirectingToCount
    );

    yield put(setRedirectingToCount(storageCount === null ? 0 : storageCount));
  } catch (err) {
    throw Error('Localforage error');
  }
}

export function* setCountToStorage(): Generator<*, *, *> {
  if (!navigator.cookieEnabled) {
    return;
  }
  try {
    const count = yield select(getRedirectingToCount);
    yield call([localforage, localforage.setItem], LOCALFORAGE_KEYS.redirectingToCount, count);
  } catch (err) {
    throw Error('Localforage error');
  }
}

export function* redirectToSource({ payload }: TrovitAction): Generator<*, *, *> {
  yield call(delay, REDIRECT_DELAY_TIME);
  yield put(incrementRedirectingToCount());

  window.location = payload;
}

export default function* redirectingToSagas(): Generator<*, *, *> {
  yield takeLatest(LOAD_REDIRECTING_TO_COUNT, loadCountFromStorage);
  yield takeLatest(INCREMENT_REDIRECTING_TO_COUNT, setCountToStorage);
  yield takeLatest(REDIRECT_REDIRECTING_TO, redirectToSource);
}



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/sagas.js